// List all the supported locale
import supportedLocales from "@/config/supported-locales"

export function getSupportedLocales() {
  let annotatedLocales = []
  for (const code of Object.keys(supportedLocales)) {
    annotatedLocales.push({
      code,
      name: supportedLocales[code]
    })
  }
  return annotatedLocales
}

//Check if the browser language is included in the supported locales
export function supportedLocalesInclude(locale) {
    return Object.keys(supportedLocales).includes(locale)
}